import type {PlaybackRate} from "../types/account-settings-types.ts";

export const validatePlaybackRate = (
    input: string,
): PlaybackRate | null | undefined => {
    if (
        input === "RATE_25_PERCENT" ||
        input === "RATE_50_PERCENT" ||
        input === "RATE_75_PERCENT" ||
        input === "RATE_100_PERCENT" ||
        input === "RATE_125_PERCENT" ||
        input === "RATE_150_PERCENT" ||
        input === "RATE_175_PERCENT" ||
        input === "RATE_200_PERCENT"
    ) {
        return input;
    }
    return null;
};
